<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('SeaExport.FileUpload')"
    width="670px"
    :close-on-click-modal="false"
    :class="'cargo-cloud-file-upload app-main-inner'+(uploading?' not-click':'')"
    :append-to-body="true"
  >
    <div class="app-main-inner-row row-grid" style="display:flex;min-height:350px;padding:0">
      <cargo-ag-grid
        :grid-options="gridOptions"
        :grid-params.sync="gridParams"
        :column-defs="columnDefs"
        :row-data="rowData"
        style="width:100%"
        class="upload-table"
        no="1"
        @gridReady="params=>{gridApi=params.api}"
      />
    </div>
    <div
      v-if="showDrop"
      style="height: 70px;border: 1px solid #b4ecf4;border-top: none;background: #bcfcfc;color: black;display: flex;align-items: center;"
      @dragenter="onDragenter"
    >
      <span style="width: 100%;text-align: center;">{{ $t('Message.FileDragArea') }}</span>
    </div>
    <el-upload
      v-show="uploaderVisible"
      ref="dragUpload"
      action
      multiple
      drag
      :auto-upload="false"
      :show-file-list="false"
      :on-change="toChooseFile"
      class="drag-upload"
      @dragleave.native="onDragleave"
      @drop.native="onDrop"
    >
      <div class="drag-upload-icon" @dragenter="onInnerDragenter" @dragleave="onInnerDragleave">
        <i class="el-icon-upload" />
      </div>
    </el-upload>
    <span slot="footer" style="padding-right:30px">
      <el-upload
        action
        multiple
        :auto-upload="false"
        :show-file-list="false"
        :on-change="toChooseFile"
        style="float:left;margin-left:30px;margin-right:13px"
        no="2"
      >
        <el-button type="primary" no="3">{{ $t('SeaExport.SelectFile') }}</el-button>
      </el-upload>
      <el-button type="danger" style="float:left" no="4" @click="remove()">{{ $t('SeaExport.DeleteFile') }}</el-button>
      <el-button type="primary" no="5" @click="upload()">{{ $t('SeaExport.Upload') }}</el-button>
      <el-button no="6" @click="innerVisible=false">{{ $t('SeaExport.Close') }}</el-button>
    </span>
    <!-- 文档类别弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="docTypeTree.visible"
      :title="$t('SeaExport.Edit')"
      width="400px"
      :close-on-click-modal="false"
      class="app-main-inner"
      append-to-body
      no="7"
    >
      <div class="app-main-inner-row">
        <cargo-ag-grid
          :show-side-bar="false"
          :grid-params.sync="docTypeTree.girdParams"
          :grid-options="docTypeTree.gridOptions"
          :row-data="docTypeTree.rowData"
          style="width:350px;height:300px;padding-left:2px"
          no="8"
          @gridReady="params=>docTypeTree.gridApi=params.api"
        />
      </div>
      <span slot="footer" style="padding-right:30px">
        <el-button type="primary" no="9" @click="saveDocType()">{{ $t('common.btn.ok') }}</el-button>
        <el-button no="10" @click="docTypeTree.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
    <!-- 文件类型选择对话框 -->
    <mx-file-type-editor
      v-if="fileTypeEditor.visible"
      :visible.sync="fileTypeEditor.visible"
      :lob="finalLob"
      :file-id="fileTypeEditor.fileId"
      :file-category="fileTypeEditor.fileCategory"
      :append-to-body="true"
      :can-change-file-category="canChangeFileCategory"
      @saveFileType="saveDocType"
    />
  </el-dialog>
</template>

<script>
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { AutoIncrementNum, DocumentManage } from '@/utils/commonUtil'
import { cacheName, cache } from '@/utils/cacheManager'
import { Job } from '@/class/model/booking/Job'
import { Company } from '@/class/model/mdm/Company'
import { QuotationClient } from '@/class/model/sales/QuotationClient'
import { Quotation } from '@/class/model/price/Quotation'
import { InquiryPrice } from '@/class/model/price/InquiryPrice'
import { DocumentCategory } from '@/class/model/sys/DocumentCategory'
// import { getDocCategoryTypeTreeByLob } from '@/api/sysManage/baseConfig/docCategory'
import { getFileList, uploadStorage, deleteFile, uploadBillPaymentStorage } from '@/api/storage'
import { getLoading } from '@/utils/utilBaseElement'
import { deleteFileToWeaver } from '@/api/clearing/billPayment.js'
import { Invoice } from '@/class/model/act/Invoice'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { updateDocBliStatus } from '@/api/seaExport/seaExportJob'
import * as ChargeItemTarget from '@/class/cargo/model/parameters/ChargeItemTarget'
import MxFileTypeEditor from '@/components/Cargo/Job/mxFileTypeEditor'
import URL from '@/api/urlTranslator'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { syncJobFiles } from '@/api/storage'
import { FILE_BELONG_INQUIRY, FILE_BELONG_QUOTATION } from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'CargoCloudFileUpload',
  components: { MxFileTypeEditor },
  props: {
    visible: { type: Boolean, required: true },
    job: { type: Object, required: true },
    lob: { type: String, default: '' },
    fromLob: { type: String, default: '' },
    showAll: { type: Boolean, default: false },
    isSirui: { type: Boolean, default: false }, // 是否思锐定制化上传，false走公共
    otherParam: { type: Object, default: () => {}, required: false }, // 其他参数
    fileSize: { type: Number, required: false }, // 文件大小
    uploadFiles: { type: Array, required: false, default: null }, // 已上传列表，用于判断是否弹出提示
    shouldEncodeUuid: { type: Boolean, default: false }, // 是否对uuid进行、url编码
    fileHistoryJc: { type: Boolean, default: false },
    newFile: { type: Object, default: null },
    uploadSource: { type: String, required: false, default: '' }, // 用于CARGO-26881需求，区分代码逻辑的执行，该参数为"fileHistory"时，代表逻辑只在文件历史页签中的上传组件生效
    otherUploadFunc: { type: Function, required: false, default: null }, // 其他上传事件
    fileCategory: { type: String, default: '' }, // 用于CARGO-36783,信号旗单证中心需求,上传客户件为固定文件类型，从外面传入
    fileCategoryLabel: { type: String, default: '' }, // 用于CARGO-36783,信号旗单证中心需求,上传客户件为固定文件类型，从外面传入
    showDrop: { type: Boolean, default: false }, // 是否显示拖拽上传区域
    jobUuids: { type: Array, default: () => [] }, // 需要同时上传文件到这些job中（已经排除掉当前job的uuid）
    uploadToJobUuidsSync: { type: Boolean, default: false }, // 上传到jobUuids的这部分操作是【同步/异步】
    tenantInstructionUuid: { type: String, default: '' }, // 生成操作指令执行记录使用
    canChangeFileCategory: { type: Boolean, default: true } // 是否可以改变文件类型
  },
  data() {
    return {
      hblData: {},
      docTypeRows: {},
      innerVisible: false,
      otherProcessing: [],
      user: {},
      storageURL: '',
      gridParams: {},
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowClicked: this.rowClicked
      },
      columnDefs: [
        {
          headerName: this.$t('SeaExport.FileName'),
          colId: 'fileName',
          field: 'fileName',
          width: 175,
          cellRenderer: params => {
            if (params.data.fileId) {
              return `<a href="${URL.common.findByFileId}/${
                params.data.fileId
              }?sessionId=${
                this.user.sessionId
              }" target="_blank" style="color:blue">${params.value}</a>`
            } else {
              return params.value
            }
          }
        },
        {
          headerName: this.$t('SeaExport.FileCategory'),
          colId: 'fileType',
          field: 'fileType',
          width: 115
        },
        {
          headerName: this.$t('SeaExport.FileSize'),
          colId: 'fileSize',
          field: 'fileSize',
          width: 115,
          cellRenderer: params => {
            return params.value ? (params.value / 1024).toFixed(2) + 'KB' : ''
          }
        },
        {
          headerName: this.$t('SeaExport.UploadProgress'),
          colId: 'fileId',
          field: 'fileId',
          width: 115,
          cellRenderer: params => {
            if (params.value) {
              return `<span style="color:green">${this.$t('Message.Uploaded')}</span>`
            }
            if (this.uploading) {
              return this.$t('queryJob.uploading') + '...'
            }
            if (params.data && params.data.duplicate && params.data.duplicate === 1) {
              return this.$t('CargoMsg.Cargo_UploadedRepeatedly')
            }
            return this.$t('Message.Waiting')
          }
        },
        {
          headerName: this.$t('SeaExport.FileType'),
          colId: 'fileCategoryLabel',
          field: 'fileCategoryLabel',
          width: 115,
          cellRenderer: params => {
            let fileCategoryName
            if (params.data.fileCategory && this.docTypeMap) {
              fileCategoryName = this.docTypeMap.get(params.data.fileCategory.toUpperCase())
            }
            if (params.data.fileId) {
              return fileCategoryName || params.value
            } else {
              const methodPath = this.documentManage.getPath('showDocTypeTree')
              return `<div onclick="${methodPath}(${
                params.data.seq
              })" style="cursor:pointer">${fileCategoryName || (params.value || '&nbsp;')}</div>`
            }
          }
        },
        {
          headerName: this.$t('FileHistory.invoiceFlag'),
          colId: 'invoiceFlag',
          field: 'invoiceFlag',
          width: 120,
          cellRenderer: params => {
            const currentValue = params.data && (params.data.invoiceFlag === 0 || params.data.invoiceFlag === '0' || params.data.invoiceFlag === 1 || params.data.invoiceFlag === '1')
              ? String(params.data.invoiceFlag)
              : ''
            const yesLabel = this.$t('FileHistory.invoiceFlag_Yes')
            const noLabel = this.$t('FileHistory.invoiceFlag_No')
            const text = currentValue === '1' ? yesLabel : (currentValue === '0' ? noLabel : '')
            // 已上传文件，显示文本
            if (params.data.fileId) {
              return text
            }
            // 未上传文件，点击单元格在“空 -> 发票 -> 非发票”间切换
            const methodPath = this.documentManage.getPath('toggleInvoiceFlag')
            return `<div onclick="${methodPath}(${params.data.seq})" style="cursor:pointer">${text || '&nbsp;'}</div>`
          }
        }
      ],
      rowData: [],
      gridApi: null,
      autoIncrementNum: new AutoIncrementNum(),
      documentManage: new DocumentManage(),
      docTypeTree: {
        visible: false,
        girdParams: {},
        gridOptions: {
          // 自行实现多选
          // rowSelection: 'multiple',
          groupDefaultExpanded: 0,
          suppressRowClickSelection: true,
          treeData: true,
          getDataPath: data => {
            return data.path.split(',')
          },
          autoGroupColumnDef: {
            headerName: this.$t('SeaExport.DocumentType'),
            width: 320,
            suppressMenu: true,
            cellRendererParams: {
              suppressDoubleClickExpand: true,
              innerRenderer: params => {
                if (params.data.type === 2) {
                  const iconName = params.data.checked
                    ? 'checkbox-checked'
                    : 'checkbox-notChecked'
                  return `<svg class="svg-icon" aria-hidden="true" style="height:1.2em;width:1.2em;vertical-align:text-bottom;">
                            <use xlink:href="#icon-${iconName}"></use>
                          </svg>
                          &nbsp;${params.data.chineseName}`
                }
                return params.data.chineseName
              }
            },
            onCellClicked: params => {
              if (params.data.type === 2) {
                const checked = !params.data.checked
                // 重置所有选中
                // if (checked) {
                //   this.docTypeTree.rowData.forEach(item => {
                //     item.checked = false
                //   })
                // }
                params.data.checked = checked
                params.api.refreshCells({ force: true })
              }
            }
          },
          columnDefs: [],
          context: {
            componentParent: this
          }
        },
        rowData: [],
        gridApi: null
      },
      docTypeMap: new Map(),
      defaultDocType: '',
      defaultDocTypeLabel: '',
      uploading: false,
      loading: null,
      selectedFile: null,
      openXHQDocumentCenter: false,
      uploaderVisible: false,
      dragEvent: '',
      fileTypeEditor: {
        visible: false,
        fileId: '',
        fileCategory: ''
      }
    }
  },
  computed: {
    finalLob() {
      return this.lob || this.job.lob
    },
    setInvoiceFlag(seq, value) {
      const row = this.rowData.find(p => p.seq === seq)
      if (row) {
        row.invoiceFlag = value
        if (this.gridApi) {
          this.gridApi.refreshCells({ force: true })
        }
      }
    },
    isZh() {
      return this.$store.getters.language === 'zh'
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.initData()
      }
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.$emit('uploadDone', this.rowData)
        this.rowData = []
        this.otherProcessing = []
      }
      this.$emit('update:visible', newVal)
    }
  },
  async created() {
    if (this.visible) {
      this.innerVisible = true
      await this.initData()
    }
  },
  beforeMount() {
    const context = this
    this.documentManage.set('showDocTypeTree', function(seq) {
      context.showDocTypeTree(seq)
    })
    this.documentManage.set('toggleInvoiceFlag', function(seq) {
      context.toggleInvoiceFlag(seq)
    })
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  methods: {
    async initData() {
      await Promise.all([
        this.buildDocTypeTree(),
        cache.load(cacheName.USER, cacheName.CONFIG)
      ])
      this.user = cache.user
      this.storageURL = cache.config.get('StorageURL')
      this.openXHQDocumentCenter = !(cache.config.get('OpenXHQDocumentCenter') === '0')
      if (this.showAll) {
        await this.toQuery()
      }
      if (this.uploadFiles != null && this.uploadFiles.length === 0) {
        if (this.job.lob === 'SI') {
          this.$message.warning(this.$t('Message.PleaseUploadFileSeaImport'))
        } else if (this.job.lob === 'AE') {
          this.$message.warning(this.$t('Message.PleaseUploadFileAirExport'))
        } else if (this.job.lob === 'AI') {
          this.$message.warning(this.$t('Message.PleaseUploadFileAirImport'))
        } else if (this.job.lob === 'SE') {
          this.$message.warning(this.$t('Message.PleaseUploadFileSeaExport'))
        }
      }
      if (this.newFile) {
        this.toChooseFile(this.newFile)
      }
      if (this.uploadSource === 'fileHistory') {
        const data = await new SeaExportJob(this.job).getCargoDoc()
        if (data.length > 0) {
          if (data.find(item => item.docType === 'HBL')) {
            this.hblData = data.find((item) => {
              return item.docType === 'HBL'
            })
          }
        }
      }
    },
    toQuery() {
      const xmlParam =
        '<RequestObject><data><extendMetaData><entry><key>uuid</key><value>' +
        this.job.uuid +
        '</value></entry></extendMetaData></data></RequestObject>'
      return getFileList(xmlParam).then(res => {
        this.rowData = Array.from(res.data, p => {
          const fileName = p.fileName
          const fileType = fileName.substr(fileName.lastIndexOf('.') + 1)
          const fileCategory = p.extendMetaData.documentType || ''
          const fileCategoryLabel = this.docTypeMap.get(
            fileCategory.toUpperCase()
          )
          const invoiceFlag = p.extendMetaData && (p.extendMetaData.invoiceFlag || p.extendMetaData.invoice_type || '')
          return {
            seq: this.autoIncrementNum.getNextNum(),
            fileId: p.id,
            fileName,
            fileType,
            fileSize: p.fileSize,
            fileCategory,
            fileCategoryLabel,
            invoiceFlag,
            params: {}
          }
        })
      })
    },
    rowClicked(event) {
      if (event) {
        this.selectedFile = event.data
      }
    },
    async buildDocTypeTree() {
      this.defaultDocType = ''
      this.defaultDocTypeLabel = ''
      if (this.finalLob) {
        await DocumentCategory.getDocCategoryTypeTreeByLob({
          constructLobParent: false,
          lob: this.finalLob
        }).then(res => {
          const data = res.data.filter(p => {
            const pathArr = p.path.split(',')
            if (p.type === 1) {
              return pathArr.length === 1
            }
            if (p.type === 2) {
              return pathArr.length > 1
            }
            return false
          })
          data.forEach(item => {
            item.checked = false
            const value = this.isZh ? item.chineseName : item.englishName
            if (item.type === 2) {
              this.docTypeMap.set(item.code.toUpperCase(), value)
            }
            if (item.defaultDocumentType) {
              this.defaultDocType = item.code
              this.defaultDocTypeLabel = item.chineseName
            }
          })
          this.docTypeTree.rowData = data
        })
      } else {
        this.docTypeTree.rowData = []
      }
    },
    toChooseFile(file) {
      if (this.fileSize && this.fileSize > 1) {
        if (file.size > this.fileSize) {
          if (this.fromLob === 'OJ') {
            this.$message.warning(this.$t('Message.FileSizeExceeds4MBYouCannotUploadPleaseSendEmailSe'))
          } else {
            this.$message.warning(this.$t('Message.N1Exceeds4MBCannotUploaded'))
          }
          return
        }
      } else {
        if (file.size > 20 * 1024 * 1024) {
          this.$message.warning(this.$t('Message.N1Exceeds20MBCannotUploaded'))
          return
        }
      }
      const fileName = file.name
      const fileType = fileName.substr(fileName.lastIndexOf('.') + 1)
      const params = { file: file.raw, jobUuids: this.jobUuids.join(','), uploadToJobUuidsSync: this.uploadToJobUuidsSync }
      if (this.job instanceof Job) {
        params.jobNo = this.job.jobNo
        params.mbl = this.job.mbl
      } else if (
        this.job instanceof Company ||
        this.job instanceof QuotationClient
      ) {
        params.companyKey = this.job.uuid
      } else if (this.job instanceof Quotation) {
        if (this.job.type === SystemConstants.QUOTATION_TYPE_PRE_PORT.code) {
          params.prePortQuotationUuid = this.job.uuid
        } else if (this.job.type === SystemConstants.QUOTATION_TYPE_LAST_MILE.code) {
          params.lastMileQuotationUuid = this.job.uuid
        } else {
          params.quotationUuid = this.job.uuid
        }
        if (this.job.inquiryPriceUuid) {
          params.inquiryPriceUuid = this.job.inquiryPriceUuid
          params.belong = SystemConstants.FILE_BELONG_QUOTATION.code
        }
      } else if (this.job instanceof InquiryPrice) {
        params.inquiryPriceUuid = this.job.uuid
        params.belong = SystemConstants.FILE_BELONG_INQUIRY.code
      } else if (this.job instanceof Invoice) {
        params.invoiceUuid = this.job.uuid
      }
      params.uuid = this.shouldEncodeUuid ? encodeURIComponent(this.job.uuid) : this.job.uuid
      if (this.job.hasOwnProperty('documentType')) {
        params.documentType = this.job.documentType
      }
      params.createdBy = this.user.userId
      params.createChineseName = this.user.chineseName
      params.createEnglishName = this.user.englishName
      this.rowData.push({
        seq: this.autoIncrementNum.getNextNum(),
        fileId: '',
        fileName,
        fileType,
        fileSize: file.size,
        fileCategory: this.fileCategory || '',
        fileCategoryLabel: this.fileCategoryLabel || '',
        invoiceFlag: '',
        params
      })
    },
    async toggleInvoiceFlag(seq) {
      const row = this.rowData.find(p => p.seq === seq)
      if (!row || row.fileId) {
        return
      }
      try {
        const action = await this.$confirm(
          this.$t('FileHistory.invoiceFlag'),
          this.$t('common.tips.prompt'),
          {
            confirmButtonText: this.$t('FileHistory.invoiceFlag_Yes'),
            cancelButtonText: this.$t('FileHistory.invoiceFlag_No'),
            distinguishCancelAndClose: true,
            type: 'warning'
          }
        )
        // 点击“发票”
        if (action === 'confirm') {
          row.invoiceFlag = '1'
        }
      } catch (e) {
        // 点击“非发票”时，Element UI 抛出 'cancel'
        if (e === 'cancel') {
          row.invoiceFlag = '0'
        }
        // 关闭对话框（e === 'close'）则不修改
      }
      if (this.gridApi) {
        this.gridApi.refreshCells({ force: true })
      }
    },
    showDocTypeTree(seq) {
      if (!this.canChangeFileCategory) {
        return
      }
      // CARGO-36783 当开启信号旗单证中心时,上传客户件为固定文件类型，不允许修改
      if (this.openXHQDocumentCenter && this.fileCategoryLabel) {
        return
      }
      const rows = this.rowData.filter(p => p.seq === seq)
      if (rows.length === 0) {
        return
      }
      const fileCategory = rows[0].fileCategory.toUpperCase()
      // const fileCategories = fileCategory ? fileCategory.split(',') : []
      // this.docTypeTree.rowData.forEach(item => {
      //   if (fileCategories.length > 0 && fileCategories.includes(item.code.toUpperCase())) {
      //     item.checked = true
      //   } else {
      //     item.checked = false
      //   }
      // })
      // if (this.docTypeTree.girdParams.api) {
      //   this.docTypeTree.girdParams.api.refreshCells({ force: true })
      // }
      // this.docTypeTree.visible = true
      this.fileTypeEditor.fileCategory = fileCategory
      this.fileTypeEditor.visible = true
    },
    saveDocType(data) {
      const currentRow = this.selectedFile // this.gridApi.getSelectedRows()[0]
      // const docTypeRows = this.docTypeTree.rowData.filter(
      //   p => p.type === 2 && p.checked
      // )
      const { docTypeRows } = data
      if (docTypeRows.length > 0) {
        if (Object.keys(this.hblData).length > 0 && this.hblData.customerSelfRelease !== 1 && docTypeRows.find(item => item.chineseName.indexOf('客户自出单') !== -1)) {
          this.$message.warning(this.$t('Message.CustomerIssuing'))
        }
        let codes = ''
        let labels = ''
        let keys = ''
        for (const item of docTypeRows) {
          if (codes) {
            codes += ','
          }
          codes += item.code
          if (labels) {
            labels += ','
          }
          if (this.finalLob === 'allLob') {
            labels += this.isZh ? item.chineseName : item.englishName
          } else {
            labels += this.docTypeMap.get(item.code.toUpperCase())
          }
          if (keys) {
            keys += ','
          }
          keys += item.uuid
        }
        currentRow.fileCategory = codes
        currentRow.fileCategoryLabel = labels
        currentRow.documentTypeUuid = keys
        // 自动同步状态
        currentRow.synchronization = docTypeRows.length === 1 ? docTypeRows[0].synchronization : 0
      } else {
        currentRow.fileCategory = ''
        currentRow.fileCategoryLabel = ''
        currentRow.documentTypeUuid = ''
        currentRow.synchronization = 0
      }
      this.gridApi.refreshCells({ force: true })
      this.docTypeTree.visible = false
    },
    remove() {
      //  const rows = this.gridApi.getSelectedRows()
      if (!this.selectedFile) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      this.$confirm(
        this.$t('common.tips.confirmDelete'),
        this.$t('common.tips.prompt'),
        {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          type: 'warning'
        }
      )
        .then(async() => {
          const row = this.selectedFile
          if (this.isSirui && row.fileId) {
            const requestParams = {}
            requestParams.fileIds = row.fileId
            requestParams.billPaymentUuid = this.otherParam.billPaymentUuid
            requestParams.userId = this.otherParam.inputBy
            deleteFileToWeaver(requestParams).then(res => {
              if (res.data.result) {
                // 删除成功
                this.$message.success(this.$t('Message.DeleteSuccessfully'))
              } else {
                // 删除失败
                this.$message.warning(res.data.message)
              }
            })
          } else if (row.fileId) {
            const success = await deleteFile(row.fileId).then(res => res.data)
            if (success !== 'success') {
              this.$message.warning(this.$t('Message.DeleteFileFailed'))
              return
            }
          }
          this.rowData = this.rowData.filter(p => p.seq !== row.seq)
        })
        .catch(() => {})
    },
    async uploadFunc(billCheck) {
      const rows = this.rowData.filter(p => !p.fileId)
      if (rows.length === 0) {
        return
      }
      for (const row of rows) {
        const params = row.params
        if (['SE', 'SI', 'RE', 'RI', 'AE', 'AI', 'IE'].includes(this.finalLob)) {
          params.documentType = row.fileCategory
          params.documentName = row.fileCategoryLabel
          if (!params.documentType) {
            if (this.defaultDocType) {
              params.documentType = this.defaultDocType
              params.documentName = this.defaultDocTypeLabel
            } else {
              this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectFileType'))
              return
            }
          }
        } else {
          if (!params.hasOwnProperty('documentType')) {
            params.documentType = row.fileCategory || 'other'
          }
          params.documentName = row.fileCategoryLabel || 'other'
        }
      }
      // 来源sop看板【上传文件】指令，第一个文件上传后，需要记录指令操作记录
      if (this.tenantInstructionUuid) {
        rows[0].params.tenantInstructionUuid = this.tenantInstructionUuid
      }
      this.loading = getLoading('upload-table')
      this.uploading = true
      this.gridApi.refreshCells({ force: true })
      try {
        await Promise.all(
          Array.from(rows, p => {
            let params = JobUtils.initUploadFileParam(p.params)
            // 根据文件类型，匹配文件类型管理中配置的属性，然后赋值
            if (this.uploadSource === 'fileHistory' && params.documentType && this.docTypeTree.rowData && this.docTypeTree.rowData.length > 0) {
              const documentTypeUuidList = p.documentTypeUuid ? p.documentTypeUuid.split(',') : []
              for (const item of this.docTypeTree.rowData) {
                // 客户直接点击上传文件按钮，不选择文件，此时documentTypeUuidList为空，只能用code去匹配
                if (documentTypeUuidList && documentTypeUuidList.length > 0 && !documentTypeUuidList.includes(item.uuid)) {
                  continue
                }
                if (params.documentType === item.code) {
                  params = JobUtils.setUploadFileParam(params, item)
                  break
                }
              }
            }
            params.fileSource = ChargeItemTarget.UPLOAD.code
            if (p.invoiceFlag !== undefined && p.invoiceFlag !== '') {
              params.invoiceFlag = p.invoiceFlag
            }
            if (this.otherParam && this.otherParam.billPaymentUuid) {
              params.billPaymentUuid = this.otherParam.billPaymentUuid
            }
            if (this.otherParam && this.otherParam.customsInfoUuid) {
              params.customsInfoUuid = this.otherParam.customsInfoUuid
            }
            if (this.uploadSource === 'tblHBL' || this.uploadSource === 'tblHBL2') {
              params.hblNo = this.otherParam.hblNo
              params.hblRefNo = this.otherParam.hblRefNo
              params.xhqSendType = this.otherParam.xhqSendType
            }
            if (this.isSirui) {
              params.inputBy = this.otherParam.inputBy
              params.fileHistoryJc = this.fileHistoryJc
              return uploadBillPaymentStorage(params).then(res => {
                p.fileId = res.data
                p.fileCategory = params.documentType
                p.fileCategoryLabel = params.documentName
              })
            } else {
              if (p.duplicate && p.duplicate === 1) {
                return
              }
              return uploadStorage(params).then(res => {
                p.fileId = res.data
                p.fileCategory = params.documentType
                p.fileCategoryLabel = params.documentName
                // 报关单解析
                const types = params.documentType.split(',')
                if (billCheck && this.checkFileType(types)) {
                  this.otherProcessing.push(p)
                }
                this.$emit('uploadSuccess')
              })
            }
          })
        )
        // 代码只在文件历史页签生效
        if (this.uploadSource === 'fileHistory' && this.docTypeRows.find(item => item.chineseName.indexOf('客户自出单') !== -1)) {
          // 上传成功后修改提单签发状态
          const jobData = new SeaExportJob(this.job)
          if (jobData.signHBL) {
            const cargoDocs = await jobData.getSeaCargoDoc()
            const hblData = cargoDocs.filter((item) => {
              return item.docType === 'HBL' || item.docType === 'HBL2'
            })
            const carDocuuidList = []
            if (hblData.length > 0) {
              hblData.forEach((item) => {
                carDocuuidList.push(item.uuid)
              })
              updateDocBliStatus(carDocuuidList).then((res) => {
                if (res.ok) {
                  hblData.forEach((item) => {
                    item.bliStatus = 12
                  })
                }
              })
            }
          }
        }
        if (Number(cache.hqConfig.get('FileAutoSynchronization')) === 1) {
          // 文件历史页签-同步文件（委托/出口转进口）
          if (this.uploadSource === 'fileHistory' && (this.job.trustFromJob || this.job.relatedJob)) {
            const isExport = this.job.lob === 'SE' || this.job.lob === 'AE'
            const isExportToImportJob = this.job.relatedJobLob && this.job.relatedJobLob !== this.job.lob
            const isTrust = this.job.relatedJob
            const docTypeMap = new Map()
            for (const item of this.docTypeTree.rowData) {
              docTypeMap.set(item.code, item)
            }
            const needSyncFileIds = []
            for (const row of rows) {
              if (!row.fileCategory) {
                continue
              }
              const fileCategorys = row.fileCategory.split(',')
              for (const fileCategory of fileCategorys) {
                const docType = docTypeMap.get(fileCategory)
                if (!docType) {
                  continue
                }
                if (isExportToImportJob) {
                  if (docType.isExportToImportMode && docType.exportImportSyncFileMode === 2) {
                    if ((isExport && docType.isExportToImport) || (!isExport && docType.isImportToExport)) {
                      needSyncFileIds.push(row.fileId)
                      break
                    }
                  }
                } else {
                  if (docType.isCrossTrustMode && docType.trustSyncFileMode === 2) {
                    if ((isTrust && docType.isTrustToOperate) || (!isTrust && docType.isOperateToTrust)) {
                      needSyncFileIds.push(row.fileId)
                      break
                    }
                  }
                }
              }
            }
            if (needSyncFileIds.length > 0) {
              await syncJobFiles({ jobKey: this.job.uuid, fileIds: needSyncFileIds.join(',') })
            }
          }
        }
        const uploadSuccessCount = rows.filter(p => p.fileId).length
        if (uploadSuccessCount > 0) {
          this.$message.success(this.$t('SeaExport.UploadSuccess'))
        }
      } catch {
        const uploadSuccessCount = rows.filter(p => p.fileId).length
        const uploadFailCount = rows.filter(p => !p.fileId).length
        await this.$confirm(
          this.$t('queryJob.Upload0UploadFailed0', [uploadSuccessCount, uploadFailCount]),
          this.$t('common.tips.prompt'),
          {
            showClose: false,
            confirmButtonText: this.$t('common.btn.ok'),
            showCancelButton: false,
            type: 'warning'
          }
        )
      } finally {
        this.loading.close()
        this.uploading = false
        // 外面指定了方法，窗口不要上传完就关闭
        if (!this.otherUploadFunc) {
          this.innerVisible = false
        }
        this.$emit('uploadDoneOtherProcessing', { row: this.otherProcessing })
        this.gridApi.refreshCells({ force: true })
      }
    },
    async upload() {
      this.docTypeRows = this.docTypeTree.rowData.filter(
        p => p.type === 2 && p.checked
      )
      if (Object.keys(this.hblData).length > 0 && this.docTypeRows.length > 0 && this.docTypeRows.find(item => item.chineseName.indexOf('客户自出单') !== -1) && (this.hblData.releaseState === 10 || this.hblData.releaseState === 4)) {
        this.$confirm(this.$t('Message.CustomerIssuingTips'), this.$t('Message.Tips'), {
          confirmButtonText: this.$t('Message.Confirm'),
          cancelButtonText: this.$t('Message.Cancel'),
          type: 'warning'
        }).then(() => {
          this.uploadFunc()
        })
      } else {
        if (this.otherUploadFunc) {
          this.otherUploadFunc(this.uploadFunc)
        } else {
          this.uploadFunc()
        }
      }
    },
    onDragenter() {
      this.uploaderVisible = true
      this.dragEvent = 'dragenter'
    },
    onDragleave() {
      this.$nextTick(() => {
        if (this.dragEvent !== 'innerDragenter' && this.dragEvent !== 'innerDragleave') {
          this.uploaderVisible = false
        }
        this.dragEvent = 'dragleave'
      })
    },
    onDrop() {
      this.uploaderVisible = false
      this.dragEvent = 'drop'
    },
    onInnerDragenter() {
      this.dragEvent = 'innerDragenter'
    },
    onInnerDragleave() {
      this.dragEvent = 'innerDragleave'
    },
    checkFileType(types) {
      return (types.includes('declarations') || types.includes('customDeclarationNote') || types.includes('CUSTOMDECLARATIONNOTE'))
    }
  }
}
</script>

<style lang="scss">
.cargo-cloud-file-upload {
  .drag-upload {
    position: absolute;
    margin-top: -387px;
    margin-left: 1px;
    width: calc(100% - 22px);
    height: calc(100% - 148px);
    .el-upload {
      width: 100%;
      height: 100%;
      &-dragger {
        width: 100%;
        height: 100%;
        background-color: #b8f9fd;
        &.is-dragover {
          border: none;
        }
      }
    }
    &-icon {
      display: inline-block;
      position: absolute;
      top:50%;
      left: 50%;
      transform: translate(-50%,-50%);
      font-size: 48px;
      .el-icon-upload {
        font-size: 200px;
        color: #81d3f8;
      }
    }
  }
}
</style>
<style scoped>
.not-click {
  pointer-events: none;
}
</style>
